import { createSlice } from '@reduxjs/toolkit'

// 从localStorage获取初始状态
const getInitialState = () => {
  try {
    const token = localStorage.getItem('authToken')
    const user = localStorage.getItem('user')
    
    if (token && user) {
      return {
        user: JSON.parse(user),
        token: token,
        isAuthenticated: true,
        loading: false,
        error: null,
      }
    }
  } catch (error) {
    console.error('Error parsing stored auth data:', error)
    // 清除无效数据
    localStorage.removeItem('authToken')
    localStorage.removeItem('user')
  }
  
  return {
    user: null,
    token: null,
    isAuthenticated: false,
    loading: false,
    error: null,
  }
}

const initialState = getInitialState()

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginStart: (state) => {
      state.loading = true
      state.error = null
    },
    loginSuccess: (state, action) => {
      state.loading = false
      state.isAuthenticated = true
      state.user = action.payload.user
      state.token = action.payload.token
      state.error = null
      
      // 保存到localStorage
      try {
        localStorage.setItem('authToken', action.payload.token)
        localStorage.setItem('user', JSON.stringify(action.payload.user))
      } catch (error) {
        console.error('Error saving auth data to localStorage:', error)
      }
    },
    loginFailure: (state, action) => {
      state.loading = false
      state.isAuthenticated = false
      state.user = null
      state.token = null
      state.error = action.payload
      
      // 清除localStorage
      localStorage.removeItem('authToken')
      localStorage.removeItem('user')
    },
    logout: (state) => {
      state.user = null
      state.token = null
      state.isAuthenticated = false
      state.loading = false
      state.error = null
      
      // 清除localStorage
      localStorage.removeItem('authToken')
      localStorage.removeItem('user')
    },
    clearError: (state) => {
      state.error = null
    },
    updateUser: (state, action) => {
      if (state.user) {
        state.user = { ...state.user, ...action.payload }
        
        // 更新localStorage中的用户信息
        try {
          localStorage.setItem('user', JSON.stringify(state.user))
        } catch (error) {
          console.error('Error updating user data in localStorage:', error)
        }
      }
    },
    refreshTokenSuccess: (state, action) => {
      state.token = action.payload.token
      state.user = action.payload.user
      
      // 更新localStorage
      try {
        localStorage.setItem('authToken', action.payload.token)
        localStorage.setItem('user', JSON.stringify(action.payload.user))
      } catch (error) {
        console.error('Error updating token in localStorage:', error)
      }
    },
    refreshTokenFailure: (state) => {
      state.user = null
      state.token = null
      state.isAuthenticated = false
      state.loading = false
      state.error = 'Session expired, please login again'
      
      // 清除localStorage
      localStorage.removeItem('authToken')
      localStorage.removeItem('user')
    },
  },
})

export const { 
  loginStart, 
  loginSuccess, 
  loginFailure, 
  logout, 
  clearError,
  updateUser,
  refreshTokenSuccess,
  refreshTokenFailure
} = authSlice.actions

export default authSlice.reducer

// 选择器
export const selectAuth = (state) => state.auth
export const selectUser = (state) => state.auth.user
export const selectToken = (state) => state.auth.token
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated
export const selectAuthLoading = (state) => state.auth.loading
export const selectAuthError = (state) => state.auth.error

// 辅助函数
export const isTokenExpired = (token) => {
  if (!token) return true
  
  try {
    const payload = JSON.parse(atob(token.split('.')[1]))
    const currentTime = Date.now() / 1000
    return payload.exp < currentTime
  } catch (error) {
    return true
  }
}

// 清除所有认证数据的工具函数
export const clearAuthData = () => {
  localStorage.removeItem('authToken')
  localStorage.removeItem('user')
} 